import type { IconProps } from './IconProps';

export function CogIcon({ className }: IconProps) {
  return (
    <svg className={className} width="1em" height="1em" viewBox="0 0 24 24"
      fill="currentColor" aria-hidden="true" focusable="false">
      <path fillRule="evenodd" clipRule="evenodd" d="M19.39 8.94 L19.83 10.34 L22.37 10.36 L22.37 13.64 L19.83 13.66 L19.39 15.06 L18.71 16.36 L20.49 18.17 L18.17 20.49 L16.36 18.71 L15.06 19.39 L13.66 19.83 L13.64 22.37 L10.36 22.37 L10.34 19.83 L8.94 19.39 L7.64 18.71 L5.83 20.49 L3.51 18.17 L5.29 16.36 L4.61 15.06 L4.17 13.66 L1.63 13.64 L1.63 10.36 L4.17 10.34 L4.61 8.94 L5.29 7.64 L3.51 5.83 L5.83 3.51 L7.64 5.29 L8.94 4.61 L10.34 4.17 L10.36 1.63 L13.64 1.63 L13.66 4.17 L15.06 4.61 L16.36 5.29 L18.17 3.51 L20.49 5.83 L18.71 7.64 Z M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z" />
    </svg>
  );
}
